<script setup>

</script>
<template>
    <div class="mx-auto  animate-pulse sm:w-3/4 rounded-xl mt-5 px-8">
        <div class="h-[70px] max-w-[190px] bg-slate-300 rounded-xl col-span-2"></div>
        <div class="h-6 bg-slate-300 rounded-xl w-32 mt-5"></div>
        <div class="h-[36px] md:h-[48px] bg-slate-300 rounded-xl w-3/4 mt-1"></div>
        <div class="space-y-3 mt-5">
            <div class="h-6 bg-slate-300 rounded-xl w-36"></div>
            <div class="w-full h-10 bg-slate-300 rounded-xl"></div>
        </div>
        <div class="space-y-3 mt-5">
            <div class="h-6 bg-slate-300 rounded-xl w-36"></div>
            <div class="w-full h-10 bg-slate-300 rounded-xl"></div>
            <div class="w-full h-10 bg-slate-300 rounded-xl"></div>
        </div>
        <div class="hidden w-full h-auto bg-slate-300 rounded-xl p-6 mt-5 space-y-10">
            <div class="">
                <div class="h-4 bg-slate-400/50 rounded-xl w-20"></div>
                <div class="grid grid-cols-2 gap-1 mt-3">
                    <div class="w-full h-8 bg-slate-400/50 rounded-tl-xl"></div>
                    <div class="w-full h-8 bg-slate-400/50 rounded-tr-xl"></div>
                </div>
                <div class="w-full h-8 bg-slate-400/50 rounded-b-xl mt-1"></div>
            </div>
            <div class="h-10 bg-slate-400/50 rounded-xl w-full"></div>
        </div>
    </div>
</template>